import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  avatar_styles_default
} from "./chunk.AURHNREG.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/avatar/avatar.ts
import { t as t2 } from "i18next";
var FadvAvatar = class extends s {
  constructor() {
    super(...arguments);
    this.hasError = false;
    this.hasUpload = false;
    this.image = "";
    this.label = "";
    this.initials = "";
    this.shape = "circle";
    this.size = "small";
    this.upload = false;
  }
  firstUpdated() {
    this.handleClick = this.handleClick.bind(this);
  }
  handleImageChange() {
    this.hasError = false;
    this.resetUpload();
  }
  handleSizeChange(oldValue, newValue) {
    if (oldValue === newValue)
      return;
    emit(this, "avatar-size-change");
  }
  handleUploadPercentage() {
    if (!this.progress)
      return;
    if (!this.uploadPercentage)
      return;
    this.progress.style.backgroundImage = `conic-gradient(transparent ${this.uploadPercentage}%,rgba(255, 255, 255, 0.4) 0%,rgba(255, 255, 255, 0.4))`;
    if (this.uploadPercentage >= 100) {
      requestAnimationFrame(() => this.resetUpload());
    }
  }
  resetUpload() {
    this.uploadPercentage = void 0;
    this.hasUpload = false;
  }
  handleClick() {
    if (!this.upload)
      return;
    this.input.click();
  }
  handleInputChange() {
    var _a;
    if (!((_a = this.input.files) == null ? void 0 : _a.length))
      return;
    this.processFile(this.input.files[0]);
  }
  async processFile(file) {
    try {
      const bitmap = await createImageBitmap(file);
      const canvas = document.createElement("canvas");
      canvas.width = bitmap.width;
      canvas.height = bitmap.height;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.drawImage(bitmap, 0, 0);
        this.image = canvas.toDataURL("image/png");
        this.uploadPercentage = 0;
        requestAnimationFrame(() => {
          this.hasUpload = true;
        });
      }
    } finally {
    }
    emit(this, "avatar-upload", { detail: { image: file } });
    this.input.value = "";
  }
  renderInitials() {
    if (!this.initials)
      return w;
    return $`<div part="initials" class="avatar__initials">${this.initials}</div>`;
  }
  renderUploadIcon() {
    if (!this.upload)
      return w;
    if (this.image)
      return w;
    if (this.initials)
      return w;
    return $`<div part="icon" class="avatar__icon" aria-hidden="true"><fadv-icon name="camera" library="solid"></fadv-icon></div>`;
  }
  renderIcon() {
    if (this.initials)
      return w;
    if (this.upload)
      return w;
    return $`<div part="icon" class="avatar__icon" aria-hidden="true"><slot name="icon"><fadv-icon name="user" library="solid"></fadv-icon></slot></div>`;
  }
  renderProgress() {
    if (!this.hasUpload)
      return w;
    return $`<div class="avatar__progress"></div>`;
  }
  renderImage() {
    if (!this.image)
      return w;
    if (this["hasError"])
      return w;
    return $`<img part="image" class="avatar__image" src="${this.image}" alt="" @error="${() => this["hasError"] = true}" />`;
  }
  render() {
    if (this.upload) {
      return $`<input class="avatar__input" type="file" @change=${this.handleInputChange} accept="image/*" /><button part="base" class=${o({
        avatar: true,
        "avatar--uploadable": true,
        "avatar--circle": this.shape === "circle",
        "avatar--rounded": this.shape === "rounded",
        "avatar--square": this.shape === "square",
        "avatar--large": this.size === "large",
        "avatar--has-image": !!this.image,
        "avatar--has-upload": this.hasUpload
      })} aria-label=${this.label} @click=${this.handleClick} title=${t2("components:avatar.uploadTitle")} >${this.renderInitials()}${this.renderUploadIcon()}${this.renderImage()}${this.renderProgress()}</button>`;
    }
    return $`<div part="base" class=${o({
      avatar: true,
      "avatar--circle": this.shape === "circle",
      "avatar--rounded": this.shape === "rounded",
      "avatar--square": this.shape === "square",
      "avatar--large": this.size === "large"
    })} role="img" aria-label=${this.label} >${this.renderInitials()}${this.renderIcon()}${this.renderImage()}</div>`;
  }
};
FadvAvatar.styles = avatar_styles_default;
__decorateClass([
  t()
], FadvAvatar.prototype, "hasError", 2);
__decorateClass([
  t()
], FadvAvatar.prototype, "hasUpload", 2);
__decorateClass([
  e()
], FadvAvatar.prototype, "image", 2);
__decorateClass([
  e()
], FadvAvatar.prototype, "label", 2);
__decorateClass([
  e()
], FadvAvatar.prototype, "initials", 2);
__decorateClass([
  e({ reflect: true })
], FadvAvatar.prototype, "shape", 2);
__decorateClass([
  e({ reflect: true })
], FadvAvatar.prototype, "size", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvAvatar.prototype, "upload", 2);
__decorateClass([
  e({ type: Number, reflect: true })
], FadvAvatar.prototype, "uploadPercentage", 2);
__decorateClass([
  i(".avatar__input")
], FadvAvatar.prototype, "input", 2);
__decorateClass([
  i(".avatar__progress")
], FadvAvatar.prototype, "progress", 2);
__decorateClass([
  watch("image")
], FadvAvatar.prototype, "handleImageChange", 1);
__decorateClass([
  watch("size")
], FadvAvatar.prototype, "handleSizeChange", 1);
__decorateClass([
  watch("uploadPercentage", { waitUntilFirstUpdate: true })
], FadvAvatar.prototype, "handleUploadPercentage", 1);
FadvAvatar = __decorateClass([
  n("fadv-avatar")
], FadvAvatar);

export {
  FadvAvatar
};
